<template>
  <z-dialogo
    ref="dialogoImprimir"
    titulo="Imprimir Produtos"
    largura="700px"
    :dividers="true"
    persistent
  >
    <div slot="texto">
      <v-row dense>
        <v-col sm="6">
          <v-radio-group
            v-model="imprimir.impressao"
            label="Imprimir"
            class="mt-0 pt-0"
            @change="onChangeImpressaoRadioGroup"
          >
            <v-radio
              color="primary"
              label="Estoque"
              value="estoque"
              class="mt-2"
            ></v-radio>
            <v-radio
              color="primary"
              label="Estoque Mínimo"
              value="estoqueminimo"
            ></v-radio>
            <v-radio
              color="primary"
              label="Tabela de Preços"
              value="precos"
            ></v-radio>
            <v-radio
              color="primary"
              label="Quantidade e Valor Venda"
              value="quantidades"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col sm="6">
          <v-checkbox
            color="primary"
            v-model="imprimir.estoquezerado"
            label="Incluir Estoque Zerado"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
          ></v-checkbox>
          <!-- <v-checkbox
            color="primary"
            v-model="imprimir.somente_quantidades"
            label="Exibir apenas quantidades"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
            :disabled="['estoque', 'quantidades'].includes(imprimir.impressao) ? false : true"
          ></v-checkbox> -->
          <v-checkbox
            color="primary"
            v-model="imprimir.incluir_valor_venda"
            label="Incluir Valor de Venda"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
            :disabled="['estoque', 'quantidades'].includes(imprimir.impressao) ? false : true"
          ></v-checkbox>
          <v-checkbox
            color="primary"
            v-model="imprimir.incluir_valor_custo"
            label="Incluir Valor de Custo"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
            :disabled="['estoque', 'quantidades'].includes(imprimir.impressao) ? false : true"
          ></v-checkbox>
          <v-checkbox
            color="primary"
            v-model="imprimir.agrupado"
            label="Imprimir Agrupado"
            single-line
            :true-value="1"
            :false-value="0"
            :disabled="['estoque', 'quantidades'].includes(imprimir.impressao) ? false : true"
            @change="onChangeImprimirAgrupado"
          ></v-checkbox>
          <z-select
            v-model="imprimir.produto_grupo_id"
            label="Grupo"
            :disabled="imprimir.agrupado == 0"
            :items="$store.getters['listas/grupos']"
            clearable
          ></z-select>
          <z-select
            v-model="imprimir.ordenar_por"
            label="Ordenar Por"
            hide-details
            :items="ordenar_por"
          ></z-select>
        </v-col>
      </v-row>
    </div>

    <template #actions_right>
      <v-btn text @click="$refs.dialogoImprimir.fechar()">Cancelar</v-btn>
      <v-btn color="primary" depressed @click="confirmarImprimir">Imprimir</v-btn>
    </template>
  </z-dialogo>
</template>

<script setup>
import { ref, computed, getCurrentInstance, inject, onMounted } from 'vue';
import { parseParams } from '@/app/helpers/utils';

const { proxy } = getCurrentInstance();

const dialogoImprimir = ref(null);
const imprimir = ref({
  impressao: "estoque",
  ordenar_por: "referencia",
  agrupado: 0,
  produto_grupo_id: null,
  estoquezerado: 0,
  loja_id: 0,
  somente_quantidades: 0,
  incluir_valor_venda: 0,
  incluir_valor_custo: 0
});

const ordenar_por = computed(() => {
  return [
    { text: "Referência", value: "referencia" },
    { text: "Descrição", value: "descricao" },
    // { text: 'Descrição', value: 'descricao' },
    // { text: 'Código', value: 'codigo' },
    // { text: 'Código de Barras', value: 'codigobarras' },
    // { text: 'Grupo', value: 'grupo' },
    // { text: 'Subgrupo', value: 'subgrupo' },
  ];
});

const emit = defineEmits(['imprimir']);

const $imprimir = inject('$imprimir');

onMounted(() => {
  proxy.$store.dispatch("listas/grupos");
  imprimir.value.loja_id = proxy.$store.state.lojas.loja_atual.id;
});

function confirmarImprimir() {
  $imprimir("relatorios/produtos/imprimir?" + new URLSearchParams(parseParams(imprimir.value)).toString(), "relatorio_de_produtos.pdf");
}

function onChangeImpressaoRadioGroup() {
  if (imprimir.impressao != 'estoque') {
    imprimir.value.agrupado = 0;
    imprimir.value.somente_quantidades = null;
  }
}

function onChangeImprimirAgrupado() {
  if (imprimir.value.agrupado == 0) {
    imprimir.value.produto_grupo_id = null;
  }
}

function abrir() {
  dialogoImprimir.value.abrir();
}

defineExpose({
  abrir
});

</script>

<style lang="scss" scoped>

</style>